import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Components
// import Price from '../../../../pages/PriceCalculation/Price'
import Extent from '../../../components/Extent'

// Actions
import { ConnectOrder, deleteOrder } from '../../../../actions/orders'

// Utils
import { translation } from '../../../../utils/helpers'
import { renderFullDate } from '../../../../utils/time'
import Radio from '../../../elements/radio'

class Complaint extends Component {
  constructor (props) {
    super(props)

    this.state = {
    }

    this.onCloseDelete = this.onCloseDelete.bind(this)
    this.chooseComplaint = this.chooseComplaint.bind(this)
    this.renderOrder = this.renderOrder.bind(this)
  }

  componentDidMount () {
    this.props.updateModal({
      headerTitle: '301',
      onModalClose: this.onCloseDelete,
      bottomBarProps: {
        actionLabelText: translation('1406'),
        onActionClick: this.chooseComplaint
      }
    })
  }

  onCloseDelete () {
    this.props.onModalClose()
    if (this.props.orderdata !== undefined && this.props.orderdata.OrderId !== undefined) {
      this.props.deleteOrder(this.props.orderdata.OrderId, 0)
    }
  }

  chooseComplaint (e) {
    e.preventDefault()

    let data = {
      OldOrderId: parseInt(this.props.listingID),
      NewOrderId: this.props.orderdata.OrderId
    }

    this.props.ConnectOrder(data).then((res) => {
      // Toastr
      // window.toastr.success(translation('13439'), translation('13424'))
      this.props.redirectToOrder(data.NewOrderId)
    }, () => {
      this.props.setErrors({
        isLoading: false
      })
      // Toastr
      window.toastr.error(translation('960'), translation('216'))
    })
  }

  renderOrder (order, index) {
    const orderType = this.props.orderTypes[order.OrderType]
    const orderExtent = order.OldOrderExtent
    let extentLines = []
    if (orderExtent !== null && orderExtent !== '') {
      extentLines = orderExtent.split('\n')
    }

    const renderLine = (val, key) => {
      return (
        <p key={'extentLine_' + key}>{val}</p>
      )
    }

    return (
      <div key={index}>
        <Radio
          name='listingID'
          value={order.OrderID}
          checked={this.props.listingID === order.OrderID.toString()}
          onChange={this.props.onInputChange}
          labelText={`${translation(orderType)}, ${renderFullDate(order.Delivery)}`}
        />

        <Extent
          order={order.OrderID}
          department={this.props.bodyShop ? 1 : 0}
          extents={[{ type: 'base', editable: false, showEditeLink: false, noTitle: true, viewMode: 'simple' }]}
        />

        {extentLines !== null && extentLines.length > 0 && (
          <div className='OldOrderExtent white__box price__view'>
            {extentLines.map(renderLine)}
          </div>
        )}
      </div>
    )
  }

  render () {
    return (
      <div className='neworder__modal__complaint'>
        <label>{translation('2028')}</label>
        <div ref='addorderpopup'>
          {this.props.orderdata.PreviousOrders.map(this.renderOrder)}

          <Radio name='listingID' value='0' checked={this.props.listingID === '0'} onChange={this.props.onInputChange} labelText={translation('13408')} />
        </div>
      </div>
    )
  }
}

Complaint.propTypes = {
  listingID: PropTypes.string.isRequired,
  orderdata: PropTypes.object.isRequired,
  onInputChange: PropTypes.func.isRequired,
  setErrors: PropTypes.func.isRequired,
  redirectToOrder: PropTypes.func.isRequired,
  onModalClose: PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    orderTypes: state.common.enums.orderTypes
  }
}

export default connect(mapStateToProps, {
  ConnectOrder,
  deleteOrder
})(Complaint)



// WEBPACK FOOTER //
// ./src/app/shared/modals/NewOrdersModal/Complaint/index.js